import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import { languages } from "../../constants/languages";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import InfoIcon from "@material-ui/icons/Info";

const asPlainText = (value, fallback = "") => {
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return fallback;
};

const phaseActionLabel = (template, verb, nextFase) => {
  const name = asPlainText(nextFase && nextFase.name).trim();
  if (typeof template === "string") {
    return template.replace(/\{0\}/g, name).trim();
  }
  return (asPlainText(verb) + (name ? " " + name : "")).trim();
};

class StartNextFaseDialog extends React.Component {
  render() {
    const { fullScreen } = this.props;
    const fase = this.props.fase || {};
    const tournament = this.props.tournament || {};
    const nextFaseName = asPlainText(
      this.props.nextFase && this.props.nextFase.name
    ).trim();
    const startLabel = phaseActionLabel(
      languages.results && languages.results.startPhaseButton,
      languages.results && languages.results.start,
      this.props.nextFase
    );
    const titleLabel =
      asPlainText(languages.results && languages.results.start, "Start") +
      (nextFaseName ? " " + nextFaseName : "");
    const participantWord = asPlainText(
      tournament.individualPlayers
        ? languages.teams && languages.teams.playersLow
        : languages.tournament && languages.tournament.teamsLow
    );
    const descriptionTemplate = this.props.enableStartPhase
      ? languages.results && languages.results.startNextFaseDescription2
      : languages.results && languages.results.startNextFaseDescription;
    const description =
      typeof descriptionTemplate === "string"
        ? descriptionTemplate.replace(/\{0\}/g, participantWord)
        : asPlainText(descriptionTemplate);
    return (
      <Dialog
        fullScreen={fullScreen}
        fullWidth={true}
        maxWidth={"md"}
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle
          id="form-dialog-title"
          style={{ overflow: "hidden" }}
          title={titleLabel}
        >
          <span
            style={{
              display: "block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {titleLabel}
          </span>
        </DialogTitle>
        <DialogContent style={{ paddingTop: 0 }}>
          {fase.played !== fase.total && !this.props.enableStartPhase && (
            <Typography
              variant="body2"
              style={{
                background: "#ef9a9a",
                padding: 10,
                borderRadius: 5,
                marginBottom: 15,
              }}
            >
              <InfoIcon
                style={{
                  height: 15,
                  width: 15,
                  top: 2,
                  position: "relative",
                }}
              />
              {" " +
                asPlainText(
                  languages.results && languages.results.startNextPhaseWarning
                )}
            </Typography>
          )}
          {fase.played === fase.total && fase.total !== 0 && (
            <Typography
              variant="body2"
              style={{
                background: "#a5d6a7",
                padding: 10,
                borderRadius: 5,
                marginBottom: 15,
              }}
            >
              <InfoIcon
                style={{
                  height: 15,
                  width: 15,
                  top: 2,
                  position: "relative",
                }}
              />
              {" " +
                asPlainText(
                  languages.results && languages.results.allMatchesPlayedAlert
                )}
            </Typography>
          )}
          <DialogContentText style={{ paddingBottom: 5 }}>
            {description}
          </DialogContentText>
          {!this.props.enableStartPhase && (
            <div
              style={{
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  display: "inline-block",
                  marginRight: 15,
                  marginLeft: 2,
                }}
              >
                <div style={{ fontWeight: 500 }}>
                  {languages.tournament && languages.tournament.results}
                </div>
                <br />
                {this.props.poulesInThisFaseResults}
              </div>
              <div style={{ display: "inline-block", marginLeft: 15 }}>
                <div style={{ fontWeight: 500 }}>{nextFaseName}</div>
                <br />
                {this.props.nextFasePoules}
              </div>
            </div>
          )}
        </DialogContent>
        {this.props.errorMessage && (
          <DialogActions>
            <div>
              <Typography style={{ color: "red" }}>
                {asPlainText(this.props.errorMessage)}
              </Typography>
            </div>
          </DialogActions>
        )}
        <DialogActions>
          <Button onClick={this.props.toggleDialog} color="primary">
            {languages.general && languages.general.cancel}
          </Button>
          <Button
            onClick={this.props.handleStart}
            disabled={
              this.props.submitDisabled &&
              (this.props.enableStartPhase ? false : true)
            }
            variant="contained"
            color="primary"
            title={startLabel}
            style={{ maxWidth: "55%", minWidth: 0 }}
          >
            <span
              style={{
                display: "block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {startLabel}
            </span>
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

StartNextFaseDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(StartNextFaseDialog);
